<template>
    <div v-if="factoryInfo">
        <!-- 模具厂 -->
        <div class="container" v-if="type == '模具厂'">           
            <div class="cloud_details">
                <div class="left_logo clear">
                    <div class="left_logo_pic"><img :src="factoryInfo.logo" alt="" width="200px"></div>
                    <div class="left_logo_title"><h1>{{factoryInfo.tenancyName}}</h1>
                        <div class="person">
                            <p class="lianxi" v-if="factoryInfo.personName">联系人:{{factoryInfo.personName}}</p>|
                            <p v-if="factoryInfo.jobStartYear">从业:{{nowYear - factoryInfo.jobStartYear}}年</p>    
                        </div>
                    </div>

                </div>
                <div class="cloud_content">
                   
                    <div class="cloud_content_col">
                        <div v-if="factoryInfo.outputValue" class="col_item">
                            <img src="../../assets/images/zichan.png" alt="">
                            <div class="col_item-a"><h3>产值规模:</h3>
                                <p >{{factoryInfo.outputValue}}</p>
                            </div>
                        </div>
                        <div v-if="factoryInfo.processorInfo.employeeNumber" class="col_item">
                         <img src="../../assets/images/renshu.png" alt="">
                         <div class="col_item-a">
                            <h3>员工人数:</h3>
                            <p>{{factoryInfo.processorInfo.employeeNumber}}</p>
                        </div>
                    </div>
                    <div v-if="factoryInfo.processorInfo.businessEmail" class="col_item">
                     <img src="../../assets/images/youxiang.png" alt="">
                     <div class="col_item-a">
                        <h3>企业邮箱:</h3>
                        <p >{{factoryInfo.processorInfo.businessEmail}}</p>
                    </div>
                </div><div v-if="factoryInfo.processorInfo.location" class="col_item">
                 <img  src="../../assets/images/dizhi.png" alt="">
                 <div class="col_item-a">
                    <h3>公司地址:</h3>
                    <p >{{factoryInfo.processorInfo.location}}</p>
                </div>
            </div><div v-if="factoryInfo.processorInfo.companyCulture"  class="col_item">
             <img src="../../assets/images/qiyewenhua.png" alt="">
             <div class="col_item-a">
                <h3>企业文化:</h3>
                <p >{{factoryInfo.processorInfo.companyCulture}}</p></div>
            </div><div v-if="factoryInfo.processorInfo.certifications"  class="col_item">
             <img src="../../assets/images/zhengshu.png" alt="">
             <div class="col_item-a">
                <h3>获得证书:</h3>
                <p><div class="zhenshu" v-for="(item,index) in factoryInfo.processorInfo.certifications" :key="index">{{item}}</div>
                </p></div></div>

            </div>
        </div>
    </div>
    <div class="cloud_details_right">

        <div v-if="factoryInfo.processorInfo.mainProducts" class="chanpin waixie1"><h2>主营产品及服务:</h2><p >{{factoryInfo.processorInfo.mainProducts}}</p>
        </div>
        <div class="waixie waixie1" v-if="factoryInfo.processorInfo.processTypes.length!=0"><h2>外协需求:</h2>
            <div class="waixiexueqiu">
                <div class="xuqiu" v-for="(item,index) in factoryInfo.processorInfo.processTypes" :key="index">
                    {{item}}
                </div>
            </div>
            
        </div>
        
        <div v-if="factoryInfo.processorInfo.outsourcedPay" class="fukuan waixie1">
            <h2>付款方式:</h2>
            <p >{{factoryInfo.processorInfo.outsourcedPay}}</p>
        </div>
        <div v-if="factoryInfo.processorInfo.outsourcedScale" class="caigou waixie1">
            <h2>采购规模:</h2>
            <p>{{factoryInfo.processorInfo.outsourcedScale}}</p>
        </div>
        <div v-if="factoryInfo.processorInfo.workingAccuracy" class="jingdu waixie1">
            <h2>精度要求:</h2>
            <p>{{factoryInfo.processorInfo.workingAccuracy}} </p>
        </div>   
        <div v-if="factoryInfo.processorInfo.processRequirements" class="gongyi waixie1">
            <h2>工艺要求:</h2>
            <p> {{factoryInfo.processorInfo.processRequirements}}</p>
        </div>    
        <div v-if="factoryInfo.processorInfo.outsourcedCharger" class="lianxiren waixie1">
            <h2>联系人:</h2>
            <p>{{factoryInfo.processorInfo.outsourcedCharger}}</p>
        </div>   
        <div v-if="factoryInfo.processorInfo.outsourcedNumber" class="lianxidianhua waixie1">
            <h2>联系电话:</h2>
            <p>{{factoryInfo.processorInfo.outsourcedNumber}}</p>
        </div>
       



</div>
 <div v-if="factoryInfo.corporateVideo" >
         <h2>企业视频:</h2>
         <div class="qiyeshipin" v-for="(item,index) in factoryInfo.corporateVideo" :key="index">
            <video :src="item.filePath" controls></video>
        </div>
    </div>
<div v-if="factoryInfo.characteristics" class="qiyexiangce">
    <h2>企业相册:</h2>
    <div v-for="(item,index) in factoryInfo.characteristics" :key="index">
        <img :src="item.filePath" alt="" width="500px">
    </div>
</div>

</div>

<!-- 云加工点 -->
<div class="container" v-if="type == '云加工点'">
    <div class="cloud_Processing">
        <div class="left_logo clear">
            <div class="left_logo_pic"><img :src="factoryInfo.logo" alt="" width="200px"></div>
            <div class="left_logo_title"><h1>{{factoryInfo.charger || '未添加'}}</h1>
                <div class="Processingmobile">
                    <p class="lianxifangshi" v-if="factoryInfo.mobile">联系方式:{{factoryInfo.mobile || '未添加'}}</p>  
                </div>
            </div>
        </div>
        <div class="xiaolv">
            <div class="baogong">
                <p>{{factoryInfo.reportRate}}%</p>
                <h3>报工率:</h3 >
            </div>
            <div class="yanchi">
                <p>{{factoryInfo.delayEndRate}}%</p>
                <h3>延迟率:</h3>
            </div>
            <div class="chaoshi">
                <p>{{factoryInfo.overHourRate}}%</p>
                <h3>超时率:</h3 >
            </div>
            <div class="zhushi">
                <p>{{factoryInfo.ontimeStartRate}}%</p>
                <h3>准时率:</h3 >
            </div>  
        </div>
        <div class="content_col">
            <div v-if="factoryInfo.processTypes" class="col_item2">
             <img src="../../assets/images/leixing.png" alt="">
             <div class="col_item2_b">
                <h3>工艺类型:</h3 >
                <div class="leixing">
                   <p v-for="(item,index) in factoryInfo.processTypes" :key="index">{{item}}</p >
               </div>

           </div>
       </div>
       <div v-if="factoryInfo.specialSkill" class="col_item2">
        <img src="../../assets/images/techang.png" alt="">
        <div class="col_item2_b">
          <h3>加工特长:</h3>
          <p>{{factoryInfo.specialSkill}}</p >
      </div>

  </div>
  <div v-if="factoryInfo.workingAccuracy" class="col_item2">
    <img src="../../assets/images/jingdu.png" alt="">
    <div class="col_item2_b">
     <h3>加工精度:</h3>
     <p>{{factoryInfo.workingAccuracy}}</p >
 </div>

</div>
<div v-if="factoryInfo.usingSoftwares" class="col_item2">
    <img src="../../assets/images/biancheng .png" alt="">
    <div class="col_item2_b">
      <h3>编程软件:</h3>
      <div v-for="(item,index) in factoryInfo.usingSoftwares" :key="index">
        {{item}}
    </div>
</div>

</div>
<div v-if="factoryInfo.taskCount" class="col_item2">
    <img src="../../assets/images/renwu.png" alt="">
    <div class="col_item2_b">
       <h3>任务数:</h3>
       <p>{{factoryInfo.taskCount}}</p >
   </div>

</div>
<div v-if="factoryInfo.reportCount" class="col_item2">
    <img src="../../assets/images/baogong.png" alt="">
    <div class="col_item2_b">
      <h3>报工数:</h3>
      <p>{{factoryInfo.reportCount}}</p >
  </div>

</div>
</div>

</div>
<div v-if="equipmentInfo.equipments.length!=0">
    <h2>设备展示:</h2>
<div class="shebei">
        <div class="shebeizhanshi" v-for="(item,index) in equipmentInfo.equipments" :key="index">
<img :src="item.equipments[0].equipmentPic" alt="">
<p>{{item.processTypeName}}({{item.processTypeName.length}}台)</p >
</div>
    
</div>

</div>

<p v-if="factoryInfo.corporateVideo">微视频:</p >
<div v-for="(item,index) in factoryInfo.corporateVideo" :key="index">
    <video :src="item.Path" controls></video>
</div>
<div class="tese">
    <h2 v-if="factoryInfo.characteristics">特色照片:</h2 >
<div class="tesezhaopian" v-for="(item,index) in factoryInfo.characteristics" :key="index">
    <img :src="item.filePath" alt="">
</div>
</div>

</div>

<!-- 云供应链 -->
<div class="container yungongyinglian" v-if="type == '云供应链'">
     <div class="cloud_details">
                <div class="left_logo clear">
                    <div class="left_logo_pic"> <img :src="factoryInfo.logo" alt="" width="200px"></div>
                    <div class="left_logo_title"><h1>{{factoryInfo.tenancyName}}</h1>
                        <div class="person">
                            <p class="lianxi" v-if="factoryInfo.charger">负责人:{{factoryInfo.charger}}</p>|
                            <p v-if="factoryInfo.mobile">联系方式:{{factoryInfo.mobile}}</p>
                            <p v-if="factoryInfo.jobStartYear">成立于{{factoryInfo.jobStartYear}}年</p>
                            <p v-if="factoryInfo.location">公司地址:{{factoryInfo.location}}</p>
                        </div>
                    </div>
                </div>
    </div>
   
    <h2 v-if="factoryInfo.corporateVideo">企业视频:</h2>
    <div class="qiyeshipin" v-for="(item,index) in factoryInfo.corporateVideo" :key="index">
        <video :src="item.filePath" controls></video>
    </div>
    <div class="qiyexiangce">
          <h2 v-if="factoryInfo.characteristics">企业相册:</h2>
    <div class="xiangce" v-for="(item,index) in factoryInfo.characteristics" :key="index">
        <img :src="item.filePath" alt="">
    </div>
    <p v-if="factoryInfo.corporateVideo == null && factoryInfo.characteristics == null">---  企业还未发布动态哦，再等等  ---</p>
    </div>
  
</div>




</div>
</template>

<script>
    export default {
        data(){
            return {
                id:"",
                factoryInfo:false,
                nowYear:0,
                type:''
            }
        },
        methods:{
            getFactoryInfo(){
                this.$http.get('/v1/api/services/app/mesTenancy/getById?primary='+this.id,{
                }).then(res => {
                    var _this=this;
                    this.factoryInfo = res.result
                    console.log(this.factoryInfo)
                    // console.log('测试')
                    // console.log(this.factoryInfo.processorInfo.processTypes)
                    switch(this.factoryInfo.outputValue){
                        case 0 : _this.factoryInfo.outputValue = "小于100万";break;
                        case 1 : _this.factoryInfo.outputValue = "大于100万小于500万";break;
                        case 2 : _this.factoryInfo.outputValue = "大于500万小于1000万";break;
                        case 3 : _this.factoryInfo.outputValue = "大于1000万小于5000万";break;
                        case 4 : _this.factoryInfo.outputValue = "大于5000万小于1亿";break;
                        case 5 : this.factoryInfo.outputValue = "大于1亿";break;
                    }
                    switch(this.factoryInfo.processorInfo.employeeNumber){
                        case 0 : _this.factoryInfo.processorInfo.employeeNumber = "0~10人";break;
                        case 1 : _this.factoryInfo.processorInfo.employeeNumber = "10~20人";break;
                        case 2 : _this.factoryInfo.processorInfo.employeeNumber = "20~50人";break;
                        case 3 : _this.factoryInfo.processorInfo.employeeNumber = "50~100人";break;
                        case 4 : _this.factoryInfo.processorInfo.employeeNumber = "100~300人";break;
                        case 5 : _this.factoryInfo.processorInfo.employeeNumber = "300~500人";break;
                    }
                }).catch(error => {

                })
                this.$http.get('/v1/api/services/app/mesTenancy/GetApproveProcessInfos?tenantId='+this.id,{

                }).then(res => {
                this.equipmentInfo = res.result
                }).catch(error => {

                })

            }
        },
        created(){
            this.id = this.$route.query.id;
            this.type = this.$route.query.type;

            console.log('test',this.id,this.type)
            var now = new Date()
            this.nowYear = now.getFullYear()

            this.getFactoryInfo()
        },
        mounted: function () {
          this.getFactoryInfo()
      }
  }
</script>

<style scoped>
.container {
    width: 1200px;
    margin: 0 auto;
}
.cloud_details{

}
.left_logo {

    padding: 16px 0;
    width: 50%;
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
}

.left_logo_pic {
    margin: 0 10px;
 background: #fff;
 border-radius: 50%;
 width: 20%;
 padding-bottom: 20%;
 position: relative;
 border: 1px solid #ccc;
}

 .left_logo_pic img{
  border-radius: 50%;
-o-object-fit: cover;
 object-fit: cover;
 width: 100%;
 position: absolute;
 top: 50%;
 transform: translateY(-50%);
  }


.left_logo_title{
 width: 71%;
 border-radius: 8px;
 margin-top: 24px;
 margin-left: 24px;
 overflow: hidden;
}
.left_logo_pic img {

    border-radius: 50%;
    object-fit: cover;
}
.person{
    display: inline-block;
    text-align: center;
    background: rgba(255, 255,255, .8);
    line-height: 30px;
}
.person .lianxi{
    padding-right: 5px;
}
.person p{
    display: inline-block;
    font-size: 15px;
    font-weight: 600;
}
.cloud_content_col{
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    border-bottom: 1px solid #b0baec;
    padding-bottom: 20px;
    align-items: baseline;
}
.content_col{
      display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    border-bottom: 1px solid #b0baec;
    padding-bottom: 20px;
    align-items: baseline;
}
/*.cloud_content p{
    width: 45%;
    }*/
    .cloud_content .zhengshu{
        display: inline-block;
    }
    .col_item, .col_item2{
        width: 31%;
        display: inline-block;
        margin: 15px 0;
    }
    .col_item:last-child:nth-child(3n - 1) {
    margin-right: calc(31% + 7% / 2);
}
.waixie1:last-child:nth-child(3n - 1) {
    margin-right: calc(30% + 10% / 2);
}
    .col_item-a,.col_item2_b{
        width:74%;
        display: inline-block;
        vertical-align: middle;
        margin-left: 33px;
    }
    .col_item-a p,.col_item2_b p{
        margin-top: 5px;
    }
    .col_item img,.col_item2 img{
        width: 16%;
        display: inline-block;
        vertical-align: middle;
    }
    .cloud_details_right{
     display: flex;
     justify-content: space-between;
     flex-wrap: wrap;
     border-bottom: 1px solid #b0baec;
     margin-bottom: 25px;
     margin-top: 25px;
 }
 h2{
    display: inline-block;
    border-left: 4px solid #34a8ff;
    color: #000;
    line-height: 21px;
    padding-left: 5px;
    margin-bottom: 10px;

}
h3{
  display: inline-block;
    color: #000;
    line-height: 21px;
}
.qiyexiangce{
    margin-bottom: 60px;
    margin-top: 20px;
}
.qiyexiangce img,.tesezhaopian img{
    width: 87%;
    margin: 10px auto;
}
.chanpin,.waixie{
    width: 35%;
}
.waixie h2,.waixie .waixiexueqiu{
   
}

.chanpin p{
    width: 86%;
    font-size: 17px;
    color: #2c3e99;
    line-height: 23px;
    margin-bottom: 20px;
    letter-spacing: 0.6px;
}
.xuqiu{
   display: inline-block;
   background: #d0c3c3;
   color: #000;
   margin-right: 21px;
   border-radius: 3px;
   margin-bottom: 11px;
   margin-top: 5px;
   font-size: 17px;
   line-height: 28px;

}
.fukuan,.caigou,.jingdu,.gongyi,.lianxiren{
    width: 30%;
   margin-bottom: 25px;
    line-height: 28px;
}
.fukuan p,.caigou p,.jingdu p,.gongyi p,.lianxiren p{
    display: inline-block;
    font-size: 17px;
}
.cloud_details_right h3{
    display: inline-block;
}
.xiaolv{
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    width: 75%;
    margin: 20px auto;
}
.xiaolv h3{
    font-size: 15px;
}
/*.baogong,.yanshi,.chaoshi,.zhunshi{
    width: 23%;
}*/
.baogong p,.yanchi p,.chaoshi p,.zhushi p{
    font-size: 25px;
}
.lianxifangshi{
    margin-top: 10px;
}
.leixing,.shebei{
 display: flex;
 justify-content: space-between;
 flex-wrap: wrap;
}
.leixing p{
    width: 33%;
    display: inline-block;
}
.shebeizhanshi{
    width: 45%;
    margin: 20px;
}
.shebeizhanshi img{
    width: 100%;
}
.shebeizhanshi p{
    font-size: 20px;
    font-weight: 600;
    text-align: center;
    margin-top: 10px;
}
.tese{
    margin-bottom: 62px;
}
.yungongyinglian .person{
    text-align: inherit;
}
.yungongyinglian .person p{
    margin-right: 10px;
}
.yungongyinglian .left_logo{
        width: 60%;
}
.qiyeshipin{
    text-align: center;
}
.qiyeshipin video{
    height: 321px;
    width: 80%;
}
.xiangce{
    text-align: center;
}
.waixie1 p{
    letter-spacing: 0.6px;
}
</style>